<template>
  <f7-page id="axsr-login-page" name="axsr-login-page" @page:beforein="init()" @page:afterin="afterin" class="bg-color-white">
    <f7-navbar class="view-mobile no-border bg-color-white" :class="isShowRegisterLink == true ? '' : ' d-none'">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block class="onboarding">
      <transition name="fade">
        <f7-card
            class   ="alert alert-danger mb-20"
            v-show  ="alertCard.show"
        >
            <div v-html="alertCard.title" slot="header"></div>
            <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
      </transition>

      <f7-row><div class="text-onboarding" v-html="text1"></div></f7-row>
      <f7-row><div class="mt-xl fs-16 b sub-text-onboarding" style="" v-html="text2"></div></f7-row>

      <f7-button large fill class="bg-color-red2 text-color-white mb-20 display-flex align-items-center justify-content-center b fs-16" @click="singpassLogin" :disabled="false">
        {{$t('login-login-with')}} <img :src="require('@/assets/img/icon/icon-singpass.svg')" class="ml-sm img-white" style="height:15px; margin-top: 6px;" />
      </f7-button>

      <div class="my-2 re-anchor-wrapper">
        <Recaptcha v-if="isShowRecaptchaV2 && sitekeyV2 != ''" :sitekey="sitekeyV2" name="login" @validate-form="validateNextButton"/>
      </div>

      <div class="fs-12 text-color-black text-align-center" @click="setIsAxsr(true)" v-html="$t('label-tnc-login', ['/#!/guest-tnc?axs=1'])"></div>
      <div @click="setIsSkipPartnerValidation(true);" class="text-align-center pt-xxl fs-14" :class=" isShowRegisterLink == true ? '' : ' d-none' " v-html="$t('login-register-now', ['/customerDetails'])"></div>
    </f7-block>

    <ModalInfo
      :modal-title="modalInfo.title"
      :modal-content="modalInfo.content"
      :sheet-opened="modalInfo.opened"
      :buttons="modalInfo.buttons"
      @closeModal="closeModal($event)"
    />

    <!-- <f7-toolbar no-hairline="true" position="bottom">something 2</f7-toolbar> -->
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import Recaptcha from '../components/Recaptcha.vue';
  import ModalInfo from '../components/sheet-modal-info.vue'
  import CryptoAES from 'aes-ecb'
  import store from '../store'
  import ApiService from "../services/api-main";
  import TokenService from '../services/token-service';

  export default {
    async mounted (){
      /*
      if(window.location.host == "wandrepartner.p2hdevworks.com"){ // stg axs: wandrepartner.p2hdevworks.com, stg wandr-e: wandre.p2hdevworks.com
        window.location.host = "wandre.p2hdevworks.com";
      }else if(window.location.host == "partner.wandr-e.com"){ // prod
        window.location.host = "sendmoney.wandr-e.com";
      }
      */

      /*
      const appRedirPath = await this.$api.misc.checkDeviceRedirect()
      if(appRedirPath){ window.location.href = appRedirPath; return; }
      this.determineAppBranchId(this.$f7.device.desktop)
      //console.log("state.appBranchId " + this.$store.state.misc.appBranchId);
      */

      //console.log('resetLoginState')
      this.$store.commit('auth/resetLoginState')

      this.setIsAxsr(true)
      console.log("loginpage mounted : is AXS ? "+this.isAxsr)

      this.$f7.sheet.close(".enterPINSheet", true);

      const imgURL = this.getImg('logo-wandr_e-compact.svg')

      this.text1 = this.$t('onboarding-text', [imgURL])
      this.text2 = this.$t('onboarding-text2', [imgURL])

      //let $$ = this.Dom7;
      this.getRecaptchaKey();

      window.singpassLoginCallback  = this.singpassLoginCallback;
      window.singpassLoginFailed    = this.singpassLoginFailed;
      window.addEventListener('message', this.handleSingpassMessage);
      window.addEventListener('storage', this.handleSingpassStorage);

      const ls = this.$f7route.query['ls'];

      if(ls && ls.trim() != ""){
        if(ls == "exceeded"){
          this.showAlert(true, this.$t('alert-login-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
        }
      }

      //console.log("Login screen, isAxsCrn : "+this.isAxsCrn+" ## formData cust id : "+ApiService.getFormData("axsQueryCustomerId"))
      if(this.isAxsCrn && ApiService.getFormData("axsQueryCustomerId")){
        this.isShowRegisterLink = false
      }
      
      //this.setIsWrongReloginCustomerId(true) // for testing
      console.log("loginpage mounted : isWrongReloginCustomerId ? "+this.isWrongReloginCustomerId)
    },
    destroyed() {
      if (window.singpassLoginCallback) window.singpassLoginCallback = null;
      if (window.singpassLoginFailed) window.singpassLoginFailed = null;
      window.removeEventListener('message', this.handleSingpassMessage);
      window.removeEventListener('storage', this.handleSingpassStorage);
    },
    data() {
      return {
        isNextButtonValid     : false,
        isShowRecaptchaV2     : false,
        sitekey               : "",
        sitekeyV2             : "",
        recaptcha             : "",
        recaptchaV2           : "",
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        isCaptchaVerified     : false,
        msg                   : "",
        routerTo              : "",
        componentKey          : 0,
        isRenderCaptcha       : false,
        checkWindow           : undefined,
        checkTimer            : null,
        modalInfo: {
            title   : "",
            content : "",
            opened  : false,
            buttons : []
        },
        text1: "",
        text2: "",
        isShowRegisterLink    : true
      };
    },
    methods: {
      ...mapActions('auth', ['login', 'logout']),
      ...mapActions('registration', ['setIsAxsr', 'setIsSkipPartnerValidation']),
      ...mapActions('misc', ['determineAppBranchId', 'setIsWrongReloginCustomerId']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async init(){
        this.setIsAxsr(true)
        console.log("loginpage beforein : is AXS ? "+this.isAxsr)
        if(this.isAxsRegisterIdExist){
          this.showAlert(true, this.$t('axs-regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
        }else if(this.isWrongReloginCustomerId){
          this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
        }
        //await this.logout();
      },
      async getRecaptchaKey(){
        this.showPreloader();
        const recaptchaKey = await this.$api.registration.getRecaptchaKey();
        //const recaptchaKey = {"status":"1223","message":null,"result":{}}

        if(recaptchaKey.result.siteKey && recaptchaKey.result.siteKeyV2){
          console.log("GOT THE SITEKEY")
          this.sitekey = recaptchaKey.result.siteKey;
          this.sitekeyV2 = recaptchaKey.result.siteKeyV2;

          if(this.sitekey != "" && this.sitekeyV2 != ""){
            this.loadScriptByURL("recaptcha-key", "https://www.google.com/recaptcha/api.js?render="+this.sitekey, function () {
              console.log("script loaded");
            });

            var registrationData = store.state.registration;
            registrationData.recaptchaV2 = "";

            this.forceRerender();
          }

          this.hidePreloader();
        }else{
          console.log("DISPLAY ERROR MSG FOR SITEKEY NULL")
          this.hidePreloader();
          this.$f7.dialog.alert(this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
        }

      },
      loadScriptByURL(id, url, callback){
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      },
      forceRerender() {
        let $$ = this.Dom7;
        $$("#slide-captcha-container").show();
        this.isShowRecaptchaV2 = false;
        this.isRenderCaptcha = true;
        this.componentKey += 1;
      },
      validateNextButton(){
        var isRecaptchaValid = false;

        if(!this.isShowRecaptchaV2 && this.sitekey != ""){
          isRecaptchaValid = true;
        }else if(this.isShowRecaptchaV2 && this.sitekeyV2 != ""){
          var registrationData = store.state.registration;
          if(registrationData.recaptchaV2.trim() != ""){
            isRecaptchaValid = true;
          }
        }

        this.isNextButtonValid = this.isEmailValid && this.isPasswordValid && isRecaptchaValid && this.isCaptchaVerified

      },
      singpassLogin(){
        const self = this;
        self.showPreloader();

        this.setIsAxsr(true)
        console.log("singpassLogin onclick : is AXS ? "+this.isAxsr)

        // Reclaim the global callback handoff every time we start our own
        // flow, in case another component (e.g. session-refresh.vue) last
        // claimed it for its own popup. See DR-2118 for the failure mode
        // this prevents - the popup calling back into a stale instance
        // whose own checkWindow has nothing to do with this popup.
        window.singpassLoginCallback = this.singpassLoginCallback;
        window.singpassLoginFailed   = this.singpassLoginFailed;

        const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
        if(!isUsingInAppBrowser) {
          self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.singpassLoginCompleted(false);} }, 1000);
        }

        if(self.$f7.device.ios && !isUsingInAppBrowser && self.checkWindow == undefined) {
          self.checkWindow = window.open('about:blank', '_blank', "fullscreen=1");
        }

        this.$api.customer.getSingpassURL(isUsingInAppBrowser, 0).then(function(response) {
          if(response && response != undefined && response.value != '') {
            if(isUsingInAppBrowser) {
              self.openMyInfoInMobile(response.value);
              self.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
                if(isUserCancel) {
                  self.singpassLoginCompleted(false);
                } else {
                  self.singpassLoginCallback(state, code);
                }
              });
            } else if(self.checkWindow !== undefined) {
              self.checkWindow.location.replace(response.value);
            } else {
              self.checkWindow = window.open(response.value, '_blank', "fullscreen=1");
            }
          } else {
            if(self.checkWindow !== undefined) {
              clearInterval(this.checkTimer);
              self.checkWindow.close();
              self.checkWindow = undefined;
            }
            self.hidePreloader();
          }
        });
      },
      handleSingpassMessage(event) {
        const allowedOrigins = [
          window.location.origin,
          process.env.VUE_APP_SINGPASS_CALLBACK_ORIGIN,
        ].filter(Boolean);
        if (!allowedOrigins.includes(event.origin)) return;
        if (event.data && event.data.type === 'singpassCallback') {
          this.singpassLoginCallback(event.data.state, event.data.code);
        }
      },
      // DR-2118 follow-up: login-singpass-callback.vue's fallback when it has no
      // window.opener reference at all (some mobile WebViews lose this even for a
      // same-origin popup) - it writes here instead, and any listening tab/window
      // picks it up via the 'storage' event, which doesn't need an opener/popup
      // object reference. Route through window.singpassLoginCallback (the reclaimed
      // global), not this.singpassLoginCallback directly, so only the currently
      // active flow's instance handles it, same as handleSingpassMessage's siblings.
      handleSingpassStorage(event) {
        if (event.key !== 'singpassCallbackPending' || !event.newValue) return;
        try {
          const payload = JSON.parse(event.newValue);
          if (window.singpassLoginCallback) {
            window.singpassLoginCallback(payload.state, payload.code);
          }
        } catch (e) {
          // malformed payload - nothing to recover
        } finally {
          localStorage.removeItem('singpassCallbackPending');
        }
      },
      singpassLoginCallback(state, code){
        if (code == '' || state == '') {
          this.singpassLoginFailed(1);
        }
        const self = this;
        self.$api.customer.singpassLogin(self.isMyInfoUseInAppBrowser(), state, code).then(function(result) {
          self.hidePreloader();
          if(result.status == '0100') {
            self.setCustomerUsingBiometry(result.result.p2hCustomerId, 2);
            self.singpassLoginCompleted(true);
          } else if(result.status == "WN00120") { // Customer not found
            self.singpassLoginFailed(2);
          } else {
            self.singpassLoginFailed(1);
          }
        }).catch(function() {
          self.singpassLoginFailed(1);
        });
      },
      singpassLoginCompleted(navigateToNextPage){
        this.hidePreloader();
        this.closePopupOnMobile();
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }
        if(navigateToNextPage) {
          this.$f7router.navigate("/home");
        }
      },
      singpassLoginFailed(errorType){
        const self = this;
        this.hidePreloader();
        this.closePopupOnMobile();
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }

        let modalTitle = "";
        let modalContent = "";
        let buttons = [];
        switch (errorType) {
          case 2: {
            // clear singpass token
            TokenService.removeToken()

            this.setIsSkipPartnerValidation(true);
            
            modalTitle    = this.$t('login-singpass-user-not-found');
            modalContent  = this.$t('login-singpass-user-not-found-desc', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK});
            let button = {};
            let imgURL = self.getImg('icon/icon-singpass.svg');
            button.index = 1;
            button.href  = "/customerDetails";
            button.text  = this.$t('login-singpass-button-register', [imgURL]);
            button.styleClass = "bg-color-red2 text-color-white vam mb-xl display-flex align-items-center justify-content-center button-square"
            buttons.push(button);
            break;
          }
          default:
            modalTitle    = this.$t('login-singpass-unavailable');
            modalContent  = "";
            break;
        }

        this.modalInfo.title = modalTitle;
        this.modalInfo.content = modalContent;
        this.modalInfo.opened = true;
        this.modalInfo.buttons = buttons;
      },
      closeModal(){
        this.modalInfo.opened = false;
      },
      async goToNextPage(){
        if (this.email != '' && this.password != '') {
          this.showPreloader();

          // CHECK EMAIL & PASSWORD VALIDITY
          var isFormValid = false;
          isFormValid = this.isEmailValid && this.isPasswordValid

          if(isFormValid){
            ApiService.saveFormData("custEmail", this.email);

            // var today = new Date();
            // var dd = String(today.getDate()).padStart(2, '0');
            // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var yy = today.getFullYear().toString().substr(-2);
            // var todayNew = MM + dd + yy;
            const randVal = await ApiService.getRandomValue();
            //console.log("newdate: "+todayNew);

            var loginData = store.state.misc;
            loginData.email = this.email;
            loginData.password = this.password;


            window.grecaptcha.ready(() => {
              window.grecaptcha.execute(this.sitekey, { action: 'submit' }).then(token => {
                //console.log("g-recaptcha-response : "+token);
                this.recaptcha = token;
                var recaptchaData = store.state.registration;
                recaptchaData.recaptcha = token;

                var secretKey = process.env.VUE_APP_PSSTK+randVal;
                //console.log("secret key : "+secretKey)

                var encryptedPassword = CryptoAES.encrypt(secretKey, this.password);
                var loginData = store.state.misc;

                this.login({userId: this.email, password: encryptedPassword }).then((result)=>{
                  //console.log(JSON.stringify(result))
                  let $$ = this.Dom7;
                  if (this.authenticationSuccess) {
                    loginData.otp.routerTo = 'loginSuccess';
                    this.$f7router.navigate("/otp");
                  }else if(result.status == "WN00115"){ // WRONG PASSWORD
                    this.showAlert(true, this.$t('login-err-WN00115'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00120"){ // UNREGISTERED EMAIL
                    this.showAlert(true, this.$t('reset-password-email-not-found'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00138"){ // MULTIPLE EMAIL EXIST
                    this.showAlert(true, this.$t('login-err-WN00138'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "0107"){ // EXCEDEED MAX ATTEMPT
                    this.showAlert(true, this.$t('alert-login-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00101"){ // error recaptcha
                    //console.log("ERROR RECAPTCHA -> display V2")
                    let $$ = this.Dom7;
                    $$("#slide-captcha-container").hide();
                    this.isShowRecaptchaV2 = true;
                    this.validateNextButton();
                  }else if(result.status == "0105"){ // EMAIL INACTIVE (TEMPORARY SUSPENDED)
                    this.showAlert(true, this.$t('reset-password-email-inactive'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00139"){ // SET PASSWORD
                    this.showAlert(true, this.$t('reset-password-no-password'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  } else {
                    // this.showAlert(true, this.$t('general-error-text') )
                    this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
                  }

                  this.hidePreloader();
                })

              });
            });

          }else{
            this.showAlert(true, this.$t('login-invalid-email-pass'));
            this.forceRerender();
            this.hidePreloader();
          }

        } else {
          //this.showAlert(true, this.$t('general-error-text'))
          //this.showAlert(true, this.$t('login-invalid-email-pass'));
          // refresh captcha
          this.$refs.sliderCaptcha.refresh()
          this.isCaptchaVerified = false;
          this.validateNextButton();
        }

      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      backButton() {
          this.setIsSkipPartnerValidation(true);

          // clear singpass token
          TokenService.removeToken()

          console.log("backButton event : back to landingpage")
          this.$f7router.navigate("/customerDetails");
      }
    },
    components: {
      Recaptcha,
      ModalInfo,
    },
    computed: {
      ...mapGetters('auth', [
            'authenticating',
            'authenticationError',
            'authenticationErrorCode',
            'authenticationSuccess',
        ]),
      ...mapGetters('misc', ['linkMarketing','isWrongReloginCustomerId']),
      ...mapGetters('registration', ['isAxsr','isAxsRegisterIdExist','isAxsCrn'])
    },
  }
</script>
